import { render, staticRenderFns } from "./CarbonTemplateDialog.vue?vue&type=template&id=dd1fbcd8&"
import script from "./CarbonTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./CarbonTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd1fbcd8')) {
      api.createRecord('dd1fbcd8', component.options)
    } else {
      api.reload('dd1fbcd8', component.options)
    }
    module.hot.accept("./CarbonTemplateDialog.vue?vue&type=template&id=dd1fbcd8&", function () {
      api.rerender('dd1fbcd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/carbon-template/CarbonTemplateDialog.vue"
export default component.exports